import axios from 'axios'
// const qs = require('qs')

const state = ({
  filialMetrics: [],
  aggregatorsIntegrationStatus: [],
})

const getters = {
  getFilialMetrics (state) {
    return state.filialMetrics
  },

  getThresholdColors (state) {
    return state.thresholdColors || {}
  },

  getAggregatorsIntegrationStatus (state) {
    return state.aggregatorsIntegrationStatus || []
  },
}

const formatTime = (val) => {
  if (val) {
    let minutes = Math.floor(val / 60)
    let seconds = val % 60
    if (minutes < 10) {
      minutes = `0${minutes}`
    }
    if (seconds < 10) {
      seconds = `0${seconds}`
    }
    return `${minutes}:${seconds}`
  } else {
    return '--:--'
  }
}

const mutations = {
  setFilialMetrics (state, data) {
    state.filialMetrics = data
  },
  clearFilialMetrics (state) {
    state.filialMetrics.map(item => {
      item.value = null
    })
  },
}

const actions = {
  fetchFilialDayMetrics ({ commit, rootGetters, rootState, dispatch }, params) {
    params = params || {
      clear: false,
    }

    if (params.clear) {
      commit('clearFilialMetrics')
    }
    const meta = {}
    meta.filialId = rootGetters['branches/getLocalStorageBranch'].id
    meta.date = rootGetters['orders/getSelectedDate']

    /* Make unique request, other pending will be canceled */
    const url = rootGetters['api/fetchDayFilialMetrics']
    const source = axios.CancelToken.source()
    dispatch('requests/addUniqueRequest', { url, source }, { root: true })

    return axios
      .get(url, {
        params: meta,
        cancelToken: source.token,
      })
      .then(res => {
        commit('setFilialMetrics', res.data.items)
      })
      .catch(err => err)
  },

  setAggregatorsIntegrationStatus ({ state }, data) {
    state.aggregatorsIntegrationStatus = data
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
